import gql from 'graphql-tag'
import { default as fragments } from './fragments'

export const MUTATION_ADDRESS = gql`
  mutation ($input: AddressMutationInput!) {
    addressMutate(input: $input) {
      address {
        id
        identity {
          id
        }
        addressType
        addressValue
        default
      }
    }
  }
`

export const MUTATION_IDENTITY = gql`
  mutation ($input: IdentityMutationInput!) {
    identityMutate(input: $input) {
      identity {
        ...Identity
        client {
          id
        }
        user {
          id
        }
        defaultAddressType
        addresses {
          edges {
            node {
              ...Address
            }
          }
        }
      }
    }
  }
  ${fragments.identity}
  ${fragments.address}
`

export const MUTATION_IDENTITY_DELETE = gql`
  mutation ($input: IdentityDeleteInput!) {
    identityDelete(input: $input) {
      outcome
    }
  }
`

export const MUTATION_CLIENT = gql`
  mutation ($input: ClientMutationInput!) {
    clientMutate(input: $input) {
      client {
        ...Client
        identity {
          id
        }
      }
    }
  }
  ${fragments.client}
`

export const MUTATION_REQUESTRUN = gql`
  mutation ($input: RequestRunMutationInput!) {
    requestrunMutate(input: $input) {
      requestrun {
        ...RequestRun
      }
    }
  }
  ${fragments.requestRun}
`

export const MUTATION_FILERELATION = gql`
  mutation ($input: FileRelationMutationInput!) {
    filerelationMutate(input: $input) {
      filerelation {
        ...FileRelation
      }
    }
  }
  ${fragments.fileRelation}
`

export const MUTATION_FILERELATION_DELETE = gql`
  mutation ($input: FileRelationDeleteInput!) {
    filerelationDelete(input: $input) {
      outcome
    }
  }
`

export const MUTATION_IDENTITYBANKACCOUNT = gql`
  mutation ($input: IdentityBankAccountMutationInput!) {
    identitybankaccountMutate(input: $input) {
      ...IdentityBankAccount
    }
  }
  ${fragments.identityBankAccount}
`

export const MUTATION_WORKFLOWRUN = gql`
  mutation ($input: WorkflowRunMutationInput!) {
    workflowrunMutate(input: $input) {
      ...WorkflowRun
    }
  }
  ${fragments.workflowRun}
`

export const MUTATION_BULKMESSAGE = gql`
  mutation($input: BulkMessageMutationInput!) {
    bulkmessageMutate(input: $input) {
      bulkmessage {
        id
        content
        description
        status
        createdAt
        scheduledAt
        numberOfFailedMessages
        hasUnsentMessages
        audience {
          id
          name
          identities {
            totalCount
          }
        }
        channels {
          edges {
            node {
              id
            }
          }
        }
        messages {
          totalCount
          edges {
            node {
              id
              status
            }
          }
        }
        telegrammessages {
          totalCount
          edges {
            node {
              id
              status
            }
          }
        }
      }
    }
  }
`

export const MUTATION_BULKMESSAGE_AUDIENCE = gql`
  mutation($input: BulkMessageAudienceMutationInput!) {
    bulkmessageaudienceMutate(input: $input) {
      bulkmessageaudience {
        id
        name
        archived
      }
    }
  }
`

export const MUTATION_EMPLOYERGROUP = gql`
  mutation($input: EmployerGroupMutationInput!) {
    employergroupMutate(input: $input) {
      employergroup {
        id
        friendlyName
        legalName
        notes
      }
    }
  }
`
export const MUTATION_EMPLOYER = gql`
  mutation($input: EmployerMutationInput!) {
    employerMutate(input: $input) {
      employer {
        id
        friendlyName
        notes
        employergroup {
          id
        }
        identity {
          id
        }
      }
    }
  }
`
export const MUTATION_DIVISION = gql`
  mutation($input: DivisionMutationInput!) {
    divisionMutate(input: $input) {
      division {
        id
        name
        employer {
          id
        }
      }
    }
  }
`
export const MUTATION_CONTACT = gql`
  mutation($input: ContactMutationInput!) {
    contactMutate(input: $input) {
      contact {
        id
        identity {
          id
        }
        employer {
          id
        }
        employergroup {
          id
        }
      }
    }
  }
`
export const MUTATION_USER = gql`
  mutation($input: UserMutationInput!) {
    userMutate(input: $input) {
      user {
        id
        email
      }
    }
  }
`
export const MUTATION_RESPONSIBILITY = gql`
  mutation($input: ResponsibilityMutationInput!) {
    responsibilityMutate(input: $input) {
      responsibility {
        id
        description
        relatedModel
        relatedId
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/mutations.js